import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
`;

export const BackgroundCircle = styled.div`
  position: absolute;
  width: 250px;
  height: 250px;
  background: #fff1e5;
  border-radius: 50%;
  z-index: 0;

  &.top-right {
    top: -115px;
    // right: 0;
    right: calc(50% - 300px - 135px);
  }

  &.bottom-left {
    bottom: -115px;
    left: calc(50% - 300px - 135px);
  }

  @media (max-width: 768px) {
    width: 180px;
    height: 180px;
    &.top-right {
      top: 20px;
      right: 20px;
    }
    &.bottom-left {
      bottom: 20px;
      left: 20px;
    }
  }
`;

export const FormWrapper = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  padding: 32px;
  width: 600px;
  z-index: 1;
`;

export const Title = styled.h2`
  font-size: 64px;
  padding: 40px 120px;
  color: #000;

  span {
    color: #f7941d;
  }

  @media (max-width: 768px) {
    font-size: 24px;
    padding: 20px 40px;
  }
`;

export const Input = styled.input`
  width: calc(100% - 32px);
  padding: 12px 14px;
  margin-bottom: 16px;
  border: 1px solid #eaeaea;
  border-radius: 6px;
  font-size: 16px;
`;

export const TextArea = styled.textarea`
  width: calc(100% - 32px);
  padding: 12px 14px;
  margin-bottom: 16px;
  border: 1px solid #eaeaea;
  border-radius: 6px;
  font-size: 16px;
`;

export const PrivacyText = styled.p`
  font-size: 13px;
  color: #000;
  margin-bottom: 16px;
`;

export const SuccessText = styled.p`
  font-size: 20px;
  color: #000;
  margin-bottom: 12px;
`;

export const PrivacyLink = styled.a`
  color: #f7941d;
  text-decoration: underline;
`;

export const Button = styled.button`
  width: 100%;
  background-color: #f7941d;
  color: #fff;
  font-weight: 600;
  padding: 12px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #e67e0d;
  }
`;
